import { BellOff } from "lucide-react";
import { formatLastMessage, chatRowClasses } from "./chatUtils";

const ChatChannelList = ({
  channels,
  currentTeamId,
  unreadCounts,
  mutedConversations,
  onSelect,
}) => {
  return channels.map((ch) => {
    const isActive = ch.team_id === currentTeamId;
    const unread = unreadCounts[ch.team_id] || 0;
    return (
      <div
        key={ch.team_id}
        data-context-menu="team-conversation"
        data-context-payload={JSON.stringify({
          team_id: ch.team_id,
          type: "channel",
          name: ch.name,
        })}
      >
        <button
          onClick={() => onSelect(ch.team_id)}
          title={ch.name}
          className={chatRowClasses(isActive)}
        >
          <span
            className="text-[10px] font-bold shrink-0"
            style={{ color: "#22C55E" }}
          >
            #
          </span>
          <span className="truncate">{ch.name}</span>
          {unread > 0 && (
            <span className="ml-auto bg-sky-500 text-white text-[10px] font-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 shrink-0">
              {unread > 99 ? "99+" : unread}
            </span>
          )}
          {unread === 0 && (
            <span className="ml-auto flex items-center gap-x-1 shrink-0">
              {mutedConversations.includes(ch.team_id) && (
                <BellOff
                  className="h-3 w-3 text-zinc-300 dark:text-zinc-600"
                  strokeWidth={2}
                />
              )}
              {ch.last_message_ts && (
                <span className="text-[10px] text-zinc-400 dark:text-zinc-600">
                  {formatLastMessage(ch.last_message_ts)}
                </span>
              )}
            </span>
          )}
        </button>
      </div>
    );
  });
};

export default ChatChannelList;
